module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.3.6-104.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.3.6.md
// module id = 522
// module chunks = 301